"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const mobx_react_lite_1 = require("mobx-react-lite");
const react_1 = tslib_1.__importDefault(require("react"));
const videoStyles_1 = require("../../styling/videoStyles");
// Styles
const styles_1 = tslib_1.__importDefault(require("./styles"));
const ControlBar = (0, mobx_react_lite_1.observer)(({ children, classes = {}, variant, ...rest }) => {
    const mergedClasses = (0, videoStyles_1.useStyles)({ source: classes, target: styles_1.default }, "controlBar");
    // Hold container className based on variant
    const containerClasses = {
        player: mergedClasses["controls--player"],
        encoder: mergedClasses["controls--encoder"],
        mini: mergedClasses["controls--mini"],
    };
    return (react_1.default.createElement("div", { className: `${mergedClasses.root} ${containerClasses[variant]}` },
        react_1.default.createElement("div", { className: mergedClasses.controls }, children)));
});
exports.default = ControlBar;
//# sourceMappingURL=index.js.map